// https://developers.google.com/interactive-media-ads/docs/sdks/html5/client-side/tags
export enum AD_TAG_URL {
  SINGLE_INLINE_LINEAR = 'Single Inline Linear',
  SINGLE_SKIPPABLE_INLINE = 'Single Skippable Inline',
  SINGLE_REDIRECT_LINEAR = 'Single Redirect Linear',
  SINGLE_REDIRECT_ERROR = 'Single Redirect Error',
  SINGLE_REDIRECT_BROKEN_FALLBACK = 'Single Redirect Broken (Fallback)',
  SINGLE_VPAID_20_LINEAR = 'Single VPAID 2.0 Linear',
  SINGLE_VPAID_20_NON_LINEAR = 'Single VPAID 2.0 Non-Linear',
  SINGLE_NON_LINEAR_INLINE = 'Single Non-linear Inline',
  VMAP_SESSION_AD_RULE_PRE_ROLL = 'VMAP Session Ad Rule Pre-roll',
  VMAP_PRE_ROLL = 'VMAP Pre-roll',
  VMAP_PRE_ROLL_BUMPER = 'VMAP Pre-roll + Bumper',
  VMAP_POST_ROLL = 'VMAP Post-roll',
  VMAP_POST_ROLL_BUMPER = 'VMAP Post-roll + Bumper',
  VMAP_PRE_MID_AND_POST_ROLLS_SINGLE_ADS = 'VMAP Pre-, Mid-, and Post-rolls, Single Ads',
  VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_STANDARD_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD = 'VMAP - Pre-roll Single Ad, Mid-roll Standard Pod with 3 ads, Post-roll Single Ad',
  VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_OPTIMIZED_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD = 'VMAP - Pre-roll Single Ad, Mid-roll Optimized Pod with 3 Ads, Post-roll Single Ad',
  VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_STANDARD_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD_BUMPERS_AROUND_ALL_AD_BREAKS = 'VMAP - Pre-roll Single Ad, Mid-roll Standard Pod with 3 Ads, Post-roll Single Ad (bumpers around all ad breaks)',
  VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_OPTIMIZED_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD_BUMPERS_AROUND_ALL_AD_BREAKS = 'VMAP - Pre-roll Single Ad, Mid-roll Optimized Pod with 3 Ads, Post-roll Single Ad (bumpers around all ad breaks)',
  VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_STANDARD_PODS_WITH_5_ADS_EVERY_10_SECONDS_POST_ROLL_SINGLE_AD = 'VMAP - Pre-roll Single Ad, Mid-roll Standard Pods with 5 Ads Every 10 Seconds, Post-roll Single Ad',
  SIMID_SURVEY_PRE_ROLL = 'SIMID Survey Pre-roll',
  OM_SDK_SAMPLE_PRE_ROLL = 'OM SDK Sample Pre-roll',
}

export const adTagUrlMap = new Map();
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_INLINE_LINEAR,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_SKIPPABLE_INLINE,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=640x480&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_REDIRECT_LINEAR,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dredirectlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_REDIRECT_ERROR,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dredirecterror&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_REDIRECT_BROKEN_FALLBACK,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dredirecterror&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&nofb=1&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_VPAID_20_LINEAR,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinearvpaid2js&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_VPAID_20_NON_LINEAR,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dnonlinearvpaid2js&ciu_szs=728x90%2C300x250&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SINGLE_NON_LINEAR_INLINE,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/nonlinear_ad_samples&sz=480x70&cust_params=sample_ct%3Dnonlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_SESSION_AD_RULE_PRE_ROLL,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sar%3Da0f2&ciu_szs=300x250&ad_rule=1&gdfp_req=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpreonly&ciu_szs=300x250%2C728x90&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL_BUMPER,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpreonlybumper&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_POST_ROLL,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpostonly&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_POST_ROLL_BUMPER,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpostonlybumper&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_MID_AND_POST_ROLLS_SINGLE_ADS,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpost&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_STANDARD_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostpod&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_OPTIMIZED_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostoptimizedpod&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_STANDARD_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD_BUMPERS_AROUND_ALL_AD_BREAKS,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostpodbumper&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_OPTIMIZED_POD_WITH_3_ADS_POST_ROLL_SINGLE_AD_BUMPERS_AROUND_ALL_AD_BREAKS,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostoptimizedpodbumper&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.VMAP_PRE_ROLL_SINGLE_AD_MID_ROLL_STANDARD_PODS_WITH_5_ADS_EVERY_10_SECONDS_POST_ROLL_SINGLE_AD,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostlongpod&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.SIMID_SURVEY_PRE_ROLL,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/simid&description_url=https%3A%2F%2Fdevelopers.google.com%2Finteractive-media-ads&sz=640x480&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
);
adTagUrlMap.set(
  AD_TAG_URL.OM_SDK_SAMPLE_PRE_ROLL,
  `https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/omid_ad_samples&env=vp&gdfp_req=1&output=vast&sz=640x480&description_url=http%3A%2F%2Ftest_site.com%2Fhomepage&vpmute=0&vpa=0&vad_format=linear&url=http%3A%2F%2Ftest_site.com&vpos=preroll&unviewed_position_start=1&correlator=`
);
